import { Box, Grid, SimpleGrid, Title } from "@mantine/core";
import React, { useEffect } from "react";
import Select from "../../../components/Select/Select";
import TextInput from "../../../components/Input/TextInput";
import { SelectItem } from "../../../components/GeneralComponents/VINSelect";
import { useQuery } from "react-query";
import { GetVinData } from "../../Dispatcher/AddTransportAssignment/GetVinData";
import { showNotification } from "@mantine/notifications";
import { LoaderWrapper } from "../../../components/GeneralComponents/LoaderWrapper";

const AddVehicleModal = ({ form, vehicles, isLoading, isFetching }) => {
  useEffect(() => {
    if (vehicles && form.values.vehicle) {
      const selectedVehicle = vehicles.data?.find((vehicle) => vehicle.id === form.values.vehicle);
      if (!selectedVehicle) return;
      form.setFieldValue("vehicle", selectedVehicle?.id);
      form.setFieldValue("vehicleTitle", selectedVehicle?.vehicleTitle);
      form.setFieldValue("vehicleVIN", selectedVehicle?.VIN);
      form.setFieldValue("make", selectedVehicle?.make);
      form.setFieldValue("model", selectedVehicle?.model);
      form.setFieldValue("exteriorColor", selectedVehicle?.exteriorColor);
      form.setFieldValue("year", selectedVehicle?.year);
      form.setFieldValue("variant", selectedVehicle.trim + " " + selectedVehicle.vehicleType + " " + selectedVehicle.driveTrain);
      form.setFieldValue("vehicleRetailPrice", selectedVehicle?.vehicleRetailPrice);
      form.setFieldValue("vehicleCostPrice", selectedVehicle?.vehicleCostPrice);
      form.setFieldValue("mileage", selectedVehicle?.mileage);
    }
  }, [form.values.vehicle, vehicles]);

  return (
    <LoaderWrapper loading={isLoading || isFetching}>
      <Grid>
        <Grid.Col md={12}>
          <Title align="center" order={2}>
            Select A Vehicle
          </Title>
        </Grid.Col>
        <Grid.Col md={12}>
          <Select
            label={"Vehicle VIN/Stock Number"}
            searchable={true}
            placeholder="Select Vehicle VIN or Stock Number"
            data={vehicles?.forSelect || []}
            form={form}
            withAsterisk={true}
            validateName="vehicle"
            itemComponent={SelectItem}
            filter={(value, item) =>
              item.title.toLowerCase().includes(value?.toLowerCase().trim()) ||
              item.label.toLowerCase().includes(value?.toLowerCase().trim()) ||
              item.description.toLowerCase().includes(value?.toLowerCase().trim()) ||
              item.VIN.toLowerCase().includes(value?.toLowerCase().trim())
            }
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <TextInput label={"Name"} placeholder="Vehicle's Name" form={form} withAsterisk={true} validateName="vehicleTitle" />
        </Grid.Col>
        <Grid.Col md={6}>
          <TextInput label={"VIN"} placeholder="Vehicle VIN" form={form} withAsterisk={true} validateName="vehicleVIN" />
        </Grid.Col>
        <Grid.Col md={6}>
          <TextInput label={"Make"} placeholder="Vehicle's Make" form={form} withAsterisk={true} validateName="make" />
        </Grid.Col>
        <Grid.Col md={6}>
          <TextInput label={"Model"} placeholder="Vehicle's Model" form={form} withAsterisk={true} validateName="model" />
        </Grid.Col>

        <Grid.Col md={6}>
          <TextInput label={"Year"} placeholder="Vehicle Year" form={form} withAsterisk={true} validateName="year" />
        </Grid.Col>
        <Grid.Col md={6}>
          <TextInput label={"Mileage"} placeholder="Vehicle's Mileage" form={form} withAsterisk={true} validateName="mileage" />
        </Grid.Col>
      </Grid>
    </LoaderWrapper>
  );
};

export default AddVehicleModal;
